export default "__VITE_ASSET__BFyisvr3__"